import React, {FC} from 'react';

import {TableCellPropsWithAvatar} from '../../../../../libs/shared/ui/src/components/tables/cells/tableCellTypes';
import {CircleModel} from '../../../../models/api/circleModel';
import {CirclesCell} from './circlesCell';

/*
 * Props.
 */

interface CircleCellProps extends TableCellPropsWithAvatar<CircleModel> {
  className?: string;
  boxedIcon?: boolean;
  displayDescription?: boolean;
}

/*
 * Component.
 */

export const CircleCell: FC<CircleCellProps> = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <CirclesCell {...props} value={props.value ? [props.value] : undefined} />
);
